export default __webpack_public_path__ + "static/media/notion.83135451.png";